module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('OverviewIcons', {
    attrs: {
      "activity": _vm.activity
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v(" " + _vm._s(_vm.activity.translations[_vm.language].name))]), _vm._v(" "), _c('DescriptionHeader', {
    attrs: {
      "activity": _vm.activity
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "description m-t-2"
  }, _vm._l((_vm.activity.translations[_vm.language].description.split('\n')), function(line) {
    return (_vm.activity.translations[_vm.language]) ? _c('p', [_vm._v("\n      " + _vm._s(line) + "\n    ")]) : _vm._e()
  }))], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b751897", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b751897"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityDescription.vue
// module id = 775
// module chunks = 3